import { Col, Form, Select, Space, Error } from 'components/common'
import { useDiscountsQuery } from 'lib/graphql/storeadmin'
import { useMemo, useState } from 'react'
import { EdgeArray } from '../templates/editor'
export interface DiscountFormProps {
  appliedDiscount?: EdgeArray
}

export type DiscountSelectOptions = Array<{
  label?: string
  value?: string
}>

export const DiscountForm = ({
  appliedDiscount,
}: DiscountFormProps): JSX.Element => {
  const { data, error } = useDiscountsQuery({
    fetchPolicy: 'cache-and-network',
  })
  useState<string>()
  // 施設エリア全体と対象施設を分ける分岐処理
  const [
    defaultStoreWideDiscount,
    defaultDiscountWithTargetProducts,
    storeWideDiscountOptions,
    discountWithTargetProductsOptions,
  ] = useMemo(() => {
    let defaultStoreWideDiscount = ''
    const defaultDiscountWithTargetProducts: string[] = []
    const storeWideDiscountOptions: DiscountSelectOptions = [
      { label: '', value: '' },
    ]
    const discountWithTargetProductsOptions: DiscountSelectOptions = []

    data?.discounts?.forEach((d) => {
      const option = { label: d.title, value: d.id }
      if (d.canOverlap) {
        discountWithTargetProductsOptions.push(option)
      } else {
        storeWideDiscountOptions.push(option)
      }
    })

    // defaultDataがある時の処理
    if (appliedDiscount) {
      for (const edge of appliedDiscount) {
        if (edge?.node?.canOverlap === false) {
          defaultStoreWideDiscount = edge.node.id
        } else if (edge?.node?.canOverlap === true) {
          defaultDiscountWithTargetProducts.push(edge.node.id)
        }
      }
    }

    return [
      defaultStoreWideDiscount,
      defaultDiscountWithTargetProducts,
      storeWideDiscountOptions,
      discountWithTargetProductsOptions,
    ]
  }, [data, appliedDiscount])

  if (error) {
    return Error.render(error)
  }

  return (
    <>
      <Col span={24}>
        <Space>
          <Form.Item
            name="storeWideDiscount"
            label="施設エリア全体適用"
            initialValue={defaultStoreWideDiscount}
          >
            <Select
              placeholder="施設エリア全体適用を選択する"
              style={{ width: '100%' }}
              options={storeWideDiscountOptions}
            />
          </Form.Item>
          <Form.Item
            name="discountWithTargetProducts"
            label="対象施設"
            initialValue={defaultDiscountWithTargetProducts}
          >
            <Select
              mode="multiple"
              placeholder="対象施設を選択する"
              style={{ width: '100%' }}
              options={discountWithTargetProductsOptions}
              // filterOption={handleSearch}
            />
          </Form.Item>
        </Space>
      </Col>
    </>
  )
}
